import { useContext } from 'react'
import { OrderContext } from '../context/OrderContext'

export const useOrderContext = () => {
	const context = useContext(OrderContext)
	return context
}
